import { render, staticRenderFns } from "./EngMessages.vue?vue&type=template&id=38e8b937&scoped=true&"
import script from "./EngMessages.vue?vue&type=script&lang=js&"
export * from "./EngMessages.vue?vue&type=script&lang=js&"
import style0 from "./EngMessages.vue?vue&type=style&index=0&id=38e8b937&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e8b937",
  null
  
)

export default component.exports